import type { RouteObject } from 'react-router';

import { aboutRoute } from './about/about.route';
import { contactRoute } from './contact/contact.route';

/**
 * The two informational surfaces, aggregated.
 *
 * A multi-route feature exports a **plural** `.routes.tsx`, so the file name
 * alone tells the router what shape to expect at import time — an array here, a
 * single object from a `.route.tsx`.
 *
 * There is **no parent route and no `/pages` landing page**: the pack's sitemap
 * carries neither, the two surfaces share a URL segment rather than a page, and
 * a crumb pointing at a route that does not exist would be worse than the
 * two-level trail each of them carries instead.
 */
export const pagesRoutes: RouteObject[] = [aboutRoute, contactRoute];
